<template>
	<div id="index">
		<header class="header">
			<div class="header-tip">
				<div class="content">
					<ul>
						<li @click="fnToWebPage('https://qlinkcc.taobao.com/?qq-pf-to=pcqq.c2c')"><i class="iconfont icon-taobao"></i>酷联商城</li>
						<li @click="fnToRouter('/404')"><i class="iconfont icon-houtai"></i>控制台</li>
					</ul>
					<div>
						开启物联网时代，请
						<el-button type="text" @click="fnToRouter('/404')">登录</el-button>
						<el-button type="text" @click="fnToRouter('/404')">注册</el-button>
					</div>
				</div>
			</div>
			<div class="header-menu">
				<div class="content">
					<img :src="img.logo" />
					<el-tabs v-model="sMenuSelected" @tab-click="fnMenu">
						<template v-for="item in $store.state.aIndexMenu">
							<el-tab-pane :label="item.name" :name="item.path"></el-tab-pane>
						</template>
					</el-tabs>
				</div>
			</div>
		</header>
		<router-view></router-view>
	</div>
</template>
<script>
	export default {
		name: "index",
		data() {
			return {
				"img": {
					"logo": require("@/assets/img/index/logo.png")
				}
			}
		},
		computed: {
			//主菜单选中值
			sMenuSelected: function() {
				var s = this.$route.path.split("/")[1];
				s = s == "" ? "home" : s;
				return this.$store.state.aIndexMenu[s].path;
			}
		},
		methods: {
			//跳转页面
			"fnMenu": function(tab, event) {
				this.fnToRouter(tab.name)
			},
		},
		components: {},
		created() {},
		watch: {
		},
		mounted() {}
	}
</script>
<style lang="less">
	@import url("../assets/font/iconfont.css");
	@import url("../assets/common.less");
	#index {
		@pc-width: 1080px;
		.header {
			width: 100%;
			min-width: @pc-width;
			z-index: 999;
			position: absolute;
			top: 0;
			.header-tip {
				@height: 25px;
				display: block;
				background-color: darken(@background-color, 5%);
				height: @height;
				& * {
					color: lighten(@font-color-blue, 20%);
					font-size: 12px;
				}
				& div,
				& li {
					height: @height;
					line-height: @height;
				}
				& li:hover,
				& li:hover *,
				& .el-button:hover,
				& .el-button:hover * {
					color: lighten(@font-color-blue, 40%);
					cursor: pointer;
				}
				& .el-button {
					border: 1px solid transparent;
				}
				& .el-button:hover {
					border: 1px solid lighten(@font-color-blue, 40%);
				}
				& i {
					padding-right: 5px;
				}
				&>.content {
					margin: 0 auto;
					width: calc(~"100% - 20px - 20px");
					padding: 0 20px 0 20px;
					overflow: hidden;
					/*工具条左侧-酷联商城-控制台*/
					&>ul {
						float: left;
						&>li {
							float: left;
							padding: 0 10px;
							&>i {
								padding-right: 5px;
							}
						}
					}
					/*工具条右侧-登录注册*/
					&>div {
						float: right;
						&>.el-button {
							padding: 2px 5px;
							&+.el-button {
								margin-left: 1px;
							}
						}
					}
				}
			}
			.header-menu {
				@height: 55px;
				background: rgba(33, 41, 48, 0.9);
				.content {
					height: @height;
					margin: 0 auto;
					width: calc(~"1080px - 20px - 20px");
					&>img {
						float: left;
						height: @height - 20px;
						margin: 10px 0;
					}
					&>.el-tabs {
						display: block;
						float: right;
						.el-tabs__header {
							margin: 0;
							height: @height;
							border: 0;
							.el-tabs__item {
								height: @height;
								line-height: @height;
								font-size: 15px;
								color: #ddd;
								&.is-active {
									color: @theme-color;
								}
							}
						}
					}
				}
			}
		}
	}
	
	.el-dropdown-menu.head-menu-drop {
		width: 98%;
		border-radius: 5px;
		background-color: #FFF;
	}
</style>


// WEBPACK FOOTER //
// Index.vue?3c551bbc